import type { ReactNode } from 'react';

type Tint = 'moss' | 'brick' | 'plum' | 'gold' | 'ember';

export function Choice({
  children,
  selected,
  tint,
  onClick,
}: {
  children: ReactNode;
  selected: boolean;
  tint?: Tint;
  onClick: () => void;
}) {
  const cls = [
    'choice',
    selected && 'choice--selected',
    selected && tint ? `choice--${tint}` : '',
  ]
    .filter(Boolean)
    .join(' ');
  return (
    <button type="button" className={cls} onClick={onClick} aria-pressed={selected}>
      {children}
    </button>
  );
}
